import * as React from "react";

module.exports = [
  {
    url: "img-medgo-accidents",
    text: "Accident / Attentat",
    whichSize: "is-small"
  },
  {
    url: "img-medgo-epidemie",
    text: "Épidémie",
    whichSize: "is-small"
  },
  {
    url: "img-medgo-climatique",
    text: "Évènement climatique",
    whichSize: "is-large"
  }
];



// WEBPACK FOOTER //
// ./assets/react/components/Landing/ArrayLandingPageMain.tsx